export default __webpack_public_path__ + "static/media/bg-fanzone-hero.e26f7dfa.png";